import {
  CssBaseline,
  createTheme,
  ThemeOptions,
  ThemeProvider,
} from '@mui/material';
import { PropsWithChildren, useEffect } from 'react';
import { useAppDispatch } from '../hooks';
import { setStyle } from '../map/map.slice';
import { getFromTheme, setTheme } from '../theme';
import riskIntelligenceTheme from './risk-intelligence';

type AppThemeProviderProps = PropsWithChildren;

function AppThemeProvider({ children }: AppThemeProviderProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    setTheme();
    dispatch(setStyle(getFromTheme('mapboxStyle')));
  }, [dispatch]);

  return (
    <ThemeProvider theme={createTheme(riskIntelligenceTheme as ThemeOptions)}>
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  );
}

export default AppThemeProvider;
